import * as React from "react";
import { Box, Typography, Divider, Link, useMediaQuery } from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import PlaceIcon from '@mui/icons-material/Place';
import logo from '../../assets/icons/logo.png';
import email from '../../assets/icons/email.png';
import phone from '../../assets/icons/phone.png';
import locationIcon from '../../assets/icons/location.png';
import theme from '../../theme';

const address =
  "အဆောင်(၉၄) ၊ အခန်း၁၅/၁၆၊ပုလဲ5လမ်းထိပ် ၊ စော်ဘွားကြီးကုန်း ၊ ရန်ကုန်မြို့။";
const additionalAddress =
  "အမှတ် ၆၃ (မြေညီထပ်)၊ ၂၅ လမ်း (အောက်ဘလောက်) ၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့။";
const businessHours =
  "9:00 AM to 5:00 PM";
const closedNotes =
  "ဥပုသ်နေ့တိုင်း နေ့တစ်ပိုင်း ပိတ်ပါသည်။ လစဉ် လပြည့်နေ့တိုင်း ဆိုင်ပိတ်ပါသည်။";
const contactNumbers = [
"09977257228",
"09977257860",
"09785668813"
];
const viberInviteLink =
  "https://invite.viber.com/?g2=AQANB5CH9mXPmlXpydBOADNepL6i6k7QbJSde2PLUla0eW8UDvsqqYHVg4RGSYR%2B";
const googleMapLink = "https://maps.app.goo.gl/sjHWmdCSJzKq4fv2A";
const viberNumbers = [
 "09977257228",
"09977257860",
"09785668813"
];
const toDialNumber = (rawNumber) => rawNumber.replace(/[^\d]/g, "");
const toViberNumber = (rawNumber) => {
  const digits = toDialNumber(rawNumber);
  if (digits.startsWith("0")) {
    return `95${digits.slice(1)}`;
  }
  return digits;
};

export function ContactInfo() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <section>
      <Box sx={{ textAlign: 'justify', marginLeft: isMobile ? '20px' : '40px', display: 'flex', gap: 2 }}>
        <img src={logo} alt="Mandalay HW logo" style={{ width: 99, objectFit: 'contain' }} />
        <Typography variant="h6" sx={{ alignSelf: 'center', fontFamily: "Amiko" }}>
          Mandalay HW
        </Typography>
      </Box>

      <Divider sx={{ mt: 2, mb: 2 }} />
      <Box sx={{ marginLeft: isMobile ? '20px' : '40px' }}>
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: isMobile ? '14px' : '16px', marginLeft: isMobile ? 0 : 2 }}>
          Connect With Us
        </Typography>
      </Box>
      <Box sx={{ marginLeft: isMobile ? '20px' : '40px', display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', fontFamily: 'Roboto, sans-serif' }}>
          <img src={locationIcon} alt="Location icon" style={{ width: 20, objectFit: 'contain' }} />
          <Typography variant="body2">
            {address}
            <br />
            {additionalAddress}
            <br />
            {businessHours}
            <br />
            {closedNotes}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={phone} alt="Phone icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">
            Contact Numbers:{" "}
            {contactNumbers.map((number, index) => (
              <React.Fragment key={number}>
                <Link
                  href={`tel:${toDialNumber(number)}`}
                  sx={{ textDecoration: 'none', color: 'inherit' }}
                >
                  {number}
                </Link>
                {index < contactNumbers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={phone} alt="Viber icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">
            Viber:{" "}
            <Link
              href={viberInviteLink}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                padding: '3px 9px',
                borderRadius: '999px',
                backgroundColor: '#7360f2',
                color: '#ffffff',
                fontWeight: 600,
                fontSize: '12px',
                boxShadow: '0 6px 16px rgba(115, 96, 242, 0.25)',
                '&:hover': { backgroundColor: '#5a48e6' },
              }}
            >
              Join our Viber Channel
            </Link>
            {viberNumbers.length > 0 && (
              <>
                {" "}
                {viberNumbers.map((number, index) => (
                  <React.Fragment key={number}>
                    <Link
                      href={`viber://chat?number=${toViberNumber(number)}`}
                      sx={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      {number}
                    </Link>
                    {index < viberNumbers.length - 1 && ", "}
                  </React.Fragment>
                ))}
              </>
            )}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={email} alt="Email icon" style={{ width: 18, objectFit: 'contain' }} />
          <Link href="mailto:mandalay.hardware@gmail.com" sx={{ textDecoration: 'none', color: 'inherit' }}>
            mandalay.hardware@gmail.com
          </Link>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <Link
            href="https://www.tiktok.com/@mandalariron?_r=1&_t=ZS-94NIRz4JYmb"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, textDecoration: 'none', color: 'inherit' }}
            aria-label="TikTok"
            title="TikTok"
          >
            <MusicNoteIcon sx={{ fontSize: 18 }} />
            <Typography variant="body2">@mandalariron</Typography>
          </Link>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <Link
            href="https://www.facebook.com/share/1GHAEMComL/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, textDecoration: 'none', color: 'inherit' }}
            aria-label="Facebook"
            title="Facebook"
          >
            <FacebookIcon sx={{ fontSize: 18 }} />
            <Typography variant="body2">Facebook Page</Typography>
          </Link>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <Link
            href={googleMapLink}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, textDecoration: 'none', color: 'inherit' }}
            aria-label="Google Map"
            title="Google Map"
          >
            <PlaceIcon sx={{ fontSize: 18 }} />
            <Typography variant="body2">Google Map</Typography>
          </Link>
        </Box>
      </Box>
    </section>
  );
}
